// AUTO-GENERATED by scripts/ts/generate-builtin-script-metadata.ts
// Imports and default icon are derived from the matching .raw.js file.
// Safe to edit — this file will not be overwritten once it exists.
import { BuiltInScriptMetadata } from "../builtInsTypes";
import { SavedSpellAspect } from "src/api/spells";

const metadata: BuiltInScriptMetadata = {
  name: "Ice Bubble",
  id: "ice-bubble",
  metadata: {
    aspect: SavedSpellAspect.Ice,
    imports: ["ice","vector","air","self","shapes","wait"],
    icon: {
      "backgroundColor": 1519958,
      "layers": [
        {
          "iconKey": "iceBolt",
          "position": {
            "x": 0,
            "y": 0
          },
          "scale": 0.95,
          "rotation": -3,
          "color": 1368319
        },
        {
          "iconKey": "air",
          "position": {
            "x": 15,
            "y": -2
          },
          "scale": 0.63,
          "rotation": 10,
          "color": 16777209
        },
        {
          "iconKey": "delay",
          "position": {
            "x": -15,
            "y": -1
          },
          "scale": 0.61,
          "rotation": -16,
          "color": 16121836
        }
      ]
    },
  },
};

export default metadata;
